import type { MouseEvent } from 'react';
import type { Enforcement } from './mockData';
import { formatZonedDate } from '@/lib/date-utils';

/**
 * Interactive cells stop click propagation: a row click expands the row, so a
 * click on a toggle, Undo or the Users count must not also expand it.
 */
export const stopRowClick = (event: MouseEvent): void => {
  event.stopPropagation();
};

/** `1 user`, `2 users` — counts read as words in labels (KIR-4704). */
export function plural(n: number, noun: string): string {
  return `${n} ${noun}${n === 1 ? '' : 's'}`;
}

/** "Blocked by X" / "Approved by X" / "Set to monitor by X" (review #18). */
export const DECIDED_BY_LABEL: Record<Enforcement, string> = {
  approve: 'Approved by',
  block: 'Blocked by',
  monitor: 'Set to monitor by',
};

export type ApprovalRecord = { by: string; date: string };

/** Full decided line, for tooltips and the detail panel. */
export function decidedBy(
  enforcement: Enforcement,
  approval: ApprovalRecord,
  timeZone: string
): string {
  const date = formatZonedDate(approval.date, timeZone, '');
  const who = `${DECIDED_BY_LABEL[enforcement]} ${approval.by}`;
  return date ? `${who}, ${date}` : who;
}
